import { authenticatedApiSlice } from "./api-provider";

// Hook that provides the authenticated API slice
export function useAuthenticatedApi() {
  // Return the static authenticated API slice
  // The authentication headers will be handled by the individual API hooks
  return authenticatedApiSlice;
}
